var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#77787A",
    d: "M.5 10.052a.842.842 0 0 0 1.004.826.84.84 0 0 0 .43-.23l7.719-7.734a4.197 4.197 0 0 1 6.85 1.365 4.21 4.21 0 0 1-.91 4.583l-8.908 8.922a1.679 1.679 0 0 1-2.847-1.196 1.68 1.68 0 0 1 .472-1.183l8.907-8.921a.841.841 0 0 0-1.19-1.191L3.12 14.215a3.365 3.365 0 0 0-.775 3.695 3.37 3.37 0 0 0 1.837 1.84 3.36 3.36 0 0 0 3.689-.777l8.907-8.921a5.893 5.893 0 0 0 0-8.327 5.875 5.875 0 0 0-8.315 0L.747 9.456a.84.84 0 0 0-.247.596"
  })));
};
export default SvgFile;